import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

function renderReactApp() {

    ReactDOM.render(
        <BrowserRouter>
            <App />
        </BrowserRouter>,
        document.getElementById('root')
    );

}

const waitForDecision = setInterval(() => {

    if (window.IS_CUSTOM_SITE === false) {

        clearInterval(waitForDecision);

        renderReactApp();

    }

}, 10);

reportWebVitals();